// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarregbookIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarregbookIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarregbookIconOutlined = function DrrpDarregbookIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarregbookIconOutlinedSvg
  }));
};

DrrpDarregbookIconOutlined.displayName = 'DrrpDarregbookIconOutlined';
export default React.forwardRef(DrrpDarregbookIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarregbookIconOutlined.js
// module id = 2525
// module chunks = 0